import { TokenInfoWrapper, TokenInfoCont } from './style'

const PlanetToken = () => {
  return (
    <TokenInfoWrapper>
      <TokenInfoCont>
        <div className="d-flex" id="wrapper">
          <div className="border-end bg-light" id="sidebar-wrapper">
            <a href="https://planet.finance/">
              <div className="sidebar-heading border-bottom bg-light">
                <img
                  src="https://blue.planetfinance.io/static/media/blue-icon.987a806f.svg"
                  alt=""
                  className="planet-finance-icon"
                />
                <p className="planet-finance-text">Planet Finance</p>
              </div>
            </a>
            <div className="list-group list-group-flush">
              {/* <div className="input-group">
            <input
              type="search"
              id="search"
              className="form-control"
              placeholder="Search"
            />
          </div> */}
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#AlpacaToken"
              >
                Alpaca
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#AQUA(PlanetFinance)"
              >
                AQUA (PlanetFinance)
              </a>

              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#BNB(Binance Coin)"
              >
                BNB (Binance Coin)
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#Binance-Peg BTCB Token"
              >
                Binance-Peg BTCB
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#BUNNY"
              >
                BUNNY
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#BUSD(Binance USD)"
              >
                BUSD (Binance USD)
              </a>

              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#Binance-Peg Cardano Token"
              >
                Binance-Peg Cardano
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#Binance-Peg ChainLink Token"
              >
                Binance-Peg ChainLink
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#CAKE(PancakeSwap)"
              >
                CAKE (PancakeSwap)
              </a>

              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#Binance-Peg Dogecoin Token"
              >
                Binance-Peg Dogecoin
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#Binance-Peg Dai Token"
              >
                Binance-Peg Dai
              </a>

              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#Binance-Peg Ethereum Token"
              >
                Binance-Peg Ethereum
              </a>

              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#Binance-Peg Litecoin Token"
              >
                Binance-Peg Litecoin
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#Binance-Peg Polkadot Token"
              >
                Binance-Peg Polkadot
              </a>

              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#Binance-Peg TrueUSD Token"
              >
                Binance-Peg TrueUSD
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#Binance-Peg Uniswap"
              >
                Binance-Peg Uniswap
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#USDC(USD Coin)"
              >
                USDC (USD Coin)
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#USDT(Tether)"
              >
                USDT (Tether)
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#Binance-Peg XRP Token"
              >
                Binance-Peg XRP
              </a>
              <a
                className="list-group-item list-group-item-action list-group-item-light p-3"
                href="#XVS"
              >
                XVS (Venus)
              </a>
            </div>
          </div>
          <div id="page-content-wrapper">
            <div className="container-fluid" id="AlpacaToken">
              <h1 className="mt-4">Alpaca</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2020-09-09
              </p>
              <p>
                <b>Total Supply</b>：157,516,297.293593 ALPACA
              </p>
              <p>
                <b>Circulation</b>：157,516,296.736787
              </p>
              <p>
                <b>White paper</b>：https://docs.alpacafinance.org/
              </p>
              <p>
                <b>Website</b>：https://www.alpacafinance.org/{" "}
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0x8f0528ce5ef7b51152a59745befdd91d97091d2f
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                Alpaca Finance is the largest lending protocol allowing leveraged
                yield farming on Binance Smart Chain. It helps lenders earn safe and
                stable yields, and offers borrowers undercollateralized loans for
                leveraged yield farming positions, vastly multiplying their farming
                principals and resulting profits.‌
              </p>

              <p>
                As an enabler for the entire DeFi ecosystem, Alpaca amplifies the
                liquidity layer of integrated exchanges, improving their capital
                efficiency by connecting LP borrowers and lenders. It's through this
                empowering function that Alpaca has become a fundamental building
                block within DeFi, helping bring the power of finance to each and
                every person's fingertips, and every alpaca's paw
              </p>
            </div>
            <div className="container-fluid" id="AQUA(PlanetFinance)">
              <h1 className="mt-4">AQUA (PlanetFinance)</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2021-05-05
              </p>
              <p>
                <b>Total Supply</b>：100,000
              </p>
              <p>
                <b>Circulation</b>：77,774.36
              </p>
              <p>
                <b>White paper</b>：--
              </p>
              <p>
                <b>Website</b>：https://docs.planetfinance.io/
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0x72B7D61E8fC8cF971960DD9cfA59B8C829D91991
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                Planet Finance, built on Binance Smart Chain (BSC), is a
                decentralized exchange for swapping BEP-20 tokens. It is fast,
                cheap, and allows anyone to participate. Users can get FLIP (LP
                token) for staking and get Aqua token as reward. Planet Finance uses
                an automated market maker (AMM) model. It means that while you trade
                digital assets on the platform, there isn’t an order book where
                you’re matched with someone else. Instead, you trade against a
                liquidity pool. Traders deposit funds into the pool, receiving
                liquidity provider (or LP) tokens in return. They can use those
                tokens to reclaim their share, plus a portion of the trading fees.
              </p>
            </div>

            <div className="container-fluid" id="BNB(Binance Coin)">
              <h1 className="mt-4">BNB (Binance Coin)</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2017-07-07
              </p>
              <p>
                <b>Total Supply</b>：184,665,938
              </p>
              <p>
                <b>Circulation</b>：152,665,937
              </p>
              <p>
                <b>White paper</b>
                ：https://resource.bnbstatic.com/books/20190418/1555582477981.pdf
              </p>
              <p>
                <b>Website</b>：https://www.binance.com/cn
              </p>
              <p>
                <b>Block Explorer</b>：https://explorer.binance.org/
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                From the ICO, Binance issued its own coin called the Binance Coin,
                with BNB as the symbol. BNB runs natively on Binance chain. The coin
                was established with a total supply of 200 million. Every quarter,
                we will destroy BNB based on the trading volume on our
                crypto-to-crypto platform until we destroy 50% of all the BNB. All
                transactions will be on the blockchain. We eventually will destroy
                100MM BNB, leaving 100MM BNB remaining. The BNB coin itself has
                multiple forms of utility, essentially being the underlying gas that
                powers the Binance Ecosystem. The current most prominent use cases
                include using BNB to: - Pay for trading fees on the exchange,
                obtaining the equivalent of a 50% discount on trades (during the
                first year). - Crypto.com has included support for Binance’s BNB
                token to its platform which includes the MCO Visa Card and mobile
                app.
              </p>
            </div>
            <div className="container-fluid" id="Binance-Peg BTCB Token">
              <h1 className="mt-4">Binance-Peg BTCB</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2020-09-02
              </p>
              <p>
                <b>Total Supply</b>：112,501 BTCB
              </p>
              <p>
                <b>Circulation</b>：105,129.557184
              </p>
              <p>
                <b>White paper</b>：https://bitcoin.org/bitcoin.pdf
              </p>
              <p>
                <b>Website</b>：https://coinmarketcap.com/currencies/bitcoin-bep2/
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                BTCB is a BEP2/BEP20 asset wrapped (pegged) on Binance Chain/Binance
                Smart Chain with a 1:1 peg to BTC locked on the Bitcoin blockchain.
                BTCB is operated on a centralized and trust-based model. The 1:1 peg
                means that the amount of wrapped BTCB is equal to the amount of BTC
                locked in a public address. The centralized and trust-based model
                implies that the issuer of the wrapped BTCB tokens is Binance. Our
                job is to ensure the impenetrable security of your funds and
                transparency.{" "}
              </p>
            </div>

            <div className="container-fluid" id="BUNNY">
              <h1 className="mt-4">Bunny</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2020-10-30
              </p>
              <p>
                <b>Total Supply</b>：12,289,550.371037 BUNNY
              </p>
              <p>
                <b>Circulation</b>：12,289,523.144831
              </p>
              <p>
                <b>White paper</b>
                ：https://pancakebunny-finance.readthedocs.io/en/main/
              </p>
              <p>
                <b>Website</b>：https://pancakebunny.finance/{" "}
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0xc9849e6fdb743d08faee3e34dd2d1bc69ea11a51
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                PancakeBunny is a decentralized finance (DeFi) yield aggregator and
                optimizer for the Binance Smart Chain, which is used for PancakeSwap
                (CAKE) and Venus (XVS), and will soon launch on Polygon (MATIC). The
                PancakeBunny protocol gives farmers the opportunity to reap the
                benefits of auto compounding.
              </p>

              <p>
                PancakeBunny is one of the largest yield aggregators across ETH and
                BSC, in terms of TVL. Farmers at PancakeBunny get permission from
                private individuals for automatic summation and reinvestment of
                yield on their behalf through mono-contracts. Users can farm on
                their own, but doing so involves a complex process of determining
                the optimal frequency and time at which to increase and reinvest
                profitability. With PancakeBunny users can delegate this process.
                The actual farming takes place on PancakeSwap and Venus.
              </p>

              <p>
                The primary goal of the platform is to support the DeFi ecosystem by
                providing users with an easy way to automatically increase their
                profitability on Binance Smart Chain. The team has a mission of
                lowering the barrier to entry to DeFi.
              </p>
            </div>

            <div className="container-fluid" id="BUSD(Binance USD)">
              <h1 className="mt-4">BUSD (Binance USD)</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2019-09-14
              </p>
              <p>
                <b>Total Supply</b>：40,562,790
              </p>
              <p>
                <b>Circulation</b>：16,651,765
              </p>
              <p>
                <b>White paper</b>
                ：https://resource.bnbstatic.com/books/20190920/1568956534319.pdf
              </p>
              <p>
                <b>Website</b>：https://www.binance.com
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://etherscan.io/token/0x4Fabb145d64652a948d72533023f6E7A623C7C53
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                Binance USD (BUSD) is a 1:1 USD-backed stable coin issued by Binance
                (in partnership with Paxos), Approved and regulated by the New York
                State Department of Financial Services (NYDFS), The BUSD Monthly
                Audit Report can be viewed from the official website. Launched on 5
                Sep 2019, BUSD aims to meld the stability of the dollar with
                blockchain technology. It is a digital fiat currency, issued as
                ERC-20 and supports BEP-2.
              </p>
            </div>

            <div className="container-fluid" id="Binance-Peg Cardano Token">
              <h1 className="mt-4">Binance-Peg Cardano</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2020-09-09
              </p>
              <p>
                <b>Total Supply</b>：280,000,000 ADA
              </p>
              <p>
                <b>Circulation</b>：236,651,241.868372
              </p>
              <p>
                <b>White paper</b>
                ：https://whitepaper.io/document/581/cardano-whitepaper
              </p>
              <p>
                <b>Website</b>：https://cardano.org/{" "}
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0x3ee2200efb3400fabb9aacf31297cbdd1d435d47
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                Cardano is a proof-of-stake blockchain platform that says its goal
                is to allow “changemakers, innovators and visionaries” to bring
                about positive global change.
              </p>

              <p>
                To learn more about this project, check out our deep dive of
                Cardano.
              </p>

              <p>
                The open-source project also aims to “redistribute power from
                unaccountable structures to the margins to individuals” — helping to
                create a society that is more secure, transparent and fair.
              </p>

              <p>
                Cardano was founded back in 2017, and named after the 16th century
                Italian polymath Gerolamo Cardano. The native ADA token takes its
                name from the 19th century mathematician Ada Lovelace, widely
                regarded as the world’s first computer programmer. The ADA token is
                designed to ensure that owners can participate in the operation of
                the network. Because of this, those who hold the cryptocurrency have
                the right to vote on any proposed changes to the software.
              </p>
            </div>
            <div className="container-fluid" id="Binance-Peg ChainLink Token">
              <h1 className="mt-4">Binance-Peg ChainLink</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2020-09-04
              </p>
              <p>
                <b>Total Supply</b>：8,600,000 LINK
              </p>
              <p>
                <b>Circulation</b>：8,124,022.166023
              </p>
              <p>
                <b>White paper</b>：https://chain.link/whitepaper
              </p>
              <p>
                <b>Website</b>：https://chain.link/{" "}
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                Founded in 2017, Chainlink is a blockchain abstraction layer that
                enables universally connected smart contracts. Through a
                decentralized oracle network, Chainlink allows blockchains to
                securely interact with external data feeds, events and payment
                methods, providing the critical off-chain information needed by
                complex smart contracts to become the dominant form of digital
                agreement.
              </p>

              <p>
                The Chainlink Network is driven by a large open-source community of
                data providers, node operators, smart contract developers,
                researchers, security auditors and more. The company focuses on
                ensuring that decentralized participation is guaranteed for all node
                operators and users looking to contribute to the network.
              </p>
            </div>
            <div className="container-fluid" id="CAKE(PancakeSwap)">
              <h1 className="mt-4">CAKE (PancakeSwap)</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2020-09-21
              </p>
              <p>
                <b>Total Supply</b>：213,278,097
              </p>
              <p>
                <b>Circulation</b>：130,470,396
              </p>
              <p>
                <b>White paper</b>：https://www.centre.io/pdfs/centre-whitepaper.pdf
              </p>
              <p>
                <b>Website</b>：https://pancakeswap.finance/
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                PancakeSwap, built on Binance Smart Chain (BSC), is a decentralized
                exchange for swapping BEP-20 tokens. It is fast, cheap, and allows
                anyone to participate. Users can get FLIP (LP token) for staking and
                get CAKE token as reward. CAKE holders can swap CAKE for SYRUP for
                additional incentivized staking. PancakeSwap uses an automated
                market maker (AMM) model. It means that while you trade digital
                assets on the platform, there isn’t an order book where you’re
                matched with someone else. Instead, you trade against a liquidity
                pool. Traders deposit funds into the pool, receiving liquidity
                provider (or LP) tokens in return. They can use those tokens to
                reclaim their share, plus a portion of the trading fees.
              </p>
            </div>

            <div className="container-fluid" id="Binance-Peg Dogecoin Token">
              <h1 className="mt-4">Binance-Peg Dogecoin</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2020-09-02
              </p>
              <p>
                <b>Total Supply</b>：1,999,999,999.999999 DOGE
              </p>
              <p>
                <b>Circulation</b>：1,494,041,791.393682
              </p>
              <p>
                <b>White paper</b>
                ：https://coinnws.com/wp-content/uploads/2019/08/dogecoin-whitepaper.pdf
              </p>
              <p>
                <b>Website</b>：https://dogecoin.com/
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0xba2ae424d960c26247dd6c32edc70b295c744c43
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                Dogecoin (DOGE) is based on the popular "doge" Internet meme and
                features a Shiba Inu on its logo. The open-source digital currency
                was created by Billy Markus from Portland, Oregon and Jackson Palmer
                from Sydney, Australia, and was forked from Litecoin in December
                2013. Dogecoin's creators envisaged it as a fun, light-hearted
                cryptocurrency that would have greater appeal beyond the core
                Bitcoin audience, since it was based on a dog meme. Tesla CEO Elon
                Musk posted several tweets on social media that Dogecoin is his
                favorite coin.
              </p>
            </div>

            <div className="container-fluid" id="Binance-Peg Dai Token">
              <h1 className="mt-4">Binance-Peg Dai</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2020-09-09
              </p>
              <p>
                <b>Total Supply</b>：261,999,999.999999
              </p>
              <p>
                <b>Circulation</b>：261,999,737.729275
              </p>
              <p>
                <b>White paper</b>：https://makerdao.com/en/whitepaper/
              </p>
              <p>
                <b>Website</b>：https://makerdao.com{" "}
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                DAI is an Ethereum-based stablecoin (stable-price cryptocurrency)
                whose issuance and development is managed by the Maker Protocol and
                the MakerDAO decentralized autonomous organization.
              </p>

              <p>
                The price of DAI is soft-pegged to the U.S. dollar and is
                collateralized by a mix of other cryptocurrencies that are deposited
                into smart-contract vaults every time new DAI is minted.
              </p>

              <p>
                It is important to differentiate between Multi-Collateral DAI and
                Single-Collateral DAI (SAI), an earlier version of the token that
                could only be collateralized by a single cryptocurrency; SAI also
                doesn’t support the DAI Savings Rate, which allows users to earn
                savings by holding DAI tokens.
              </p>
            </div>

            <div className="container-fluid" id="Binance-Peg Ethereum Token">
              <h1 className="mt-4">Binance-Peg Ethereum</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2020-09-09
              </p>
              <p>
                <b>Total Supply</b>：1,404,999.999998 ETH
              </p>
              <p>
                <b>Circulation</b>：1,351,773.966666
              </p>
              <p>
                <b>White paper</b>
                ：https://blockchainlab.com/pdf/Ethereum_white_paper-a_next_generation_smart_contract_and_decentralized_application_platform-vitalik-buterin.pdf
              </p>
              <p>
                <b>Website</b>：https://ethereum.org{" "}
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0x2170Ed0880ac9A755fd29B2688956BD959F933F8
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                BETH is a BEP2/BEP20 asset wrapped (pegged) on Binance Chain/Binance
                Smart Chain with a 1:1 peg to ETH locked on the Ethereum blockchain.
                BETH is operated on a centralized and trust-based model. The 1:1 peg
                means that the amount of wrapped BETH is equal to the amount of ETH
                locked in a public address. The centralized and trust-based model
                implies that the issuer of the wrapped BETH tokens is Binance. Our
                job is to ensure the impenetrable security of your funds and
                transparency.{" "}
              </p>
            </div>

            <div className="container-fluid" id="Binance-Peg Litecoin Token">
              <h1 className="mt-4">Binance-Peg Litecoin</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2021-05-05
              </p>
              <p>
                <b>Total Supply</b>：595,000 LTC
              </p>
              <p>
                <b>Circulation</b>：491,476.164526
              </p>
              <p>
                <b>White paper</b>
                ：https://whitepaper.io/document/683/litecoin-whitepaper
              </p>
              <p>
                <b>Website</b>：https://litecoin.org/
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0x4338665cbb7b2485a8855a139b75d5e34ab0db94
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                Litecoin (LTC) is a cryptocurrency that was designed to provide
                fast, secure and low-cost payments by leveraging the unique
                properties of blockchain technology.
              </p>

              <p>
                The cryptocurrency was created based on the Bitcoin (BTC) protocol,
                but it differs in terms of the hashing algorithm used, hard cap,
                block transaction times and a few other factors. Litecoin has a
                block time of just 2.5 minutes and extremely low transaction fees,
                making it suitable for micro-transactions and point-of-sale
                payments.
              </p>
            </div>

            <div className="container-fluid" id="Binance-Peg Polkadot Token">
              <h1 className="mt-4">Binance-Peg Polkadot</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2020-09-09
              </p>
              <p>
                <b>Total Supply</b>：15,999,999.991309 DOT
              </p>
              <p>
                <b>Circulation</b>：14,895,081.943739
              </p>
              <p>
                <b>White paper</b>：https://polkadot.network/PolkaDotPaper.pdf
              </p>
              <p>
                <b>Website</b>：https://polkadot.network/{" "}
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0x7083609fce4d1d8dc0c979aab8c869ea2c873402
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                Polkadot is an open-source sharding multichain protocol that
                facilitates the cross-chain transfer of any data or asset types, not
                just tokens, thereby making a wide range of blockchains
                interoperable with each other.
              </p>

              <p>
                This interoperability seeks to establish a fully decentralized and
                private web, controlled by its users, and simplify the creation of
                new applications, institutions and services.
              </p>

              <p>
                The Polkadot protocol connects public and private chains,
                permissionless networks, oracles and future technologies, allowing
                these independent blockchains to trustlessly share information and
                transactions through the Polkadot relay chain (explained further
                down).
              </p>

              <p>
                Polkadot’s native DOT token serves three clear purposes: providing
                network governance and operations, and creating parachains (parallel
                chains) by bonding.
              </p>

              <p>Polkadot has four core components:</p>

              <p>
                Relay Chain: Polkadot’s “heart,” helping to create consensus,
                interoperability and shared security across the network of different
                chains;
              </p>
              <p>
                Parachains: independent chains that can have their own tokens and be
                optimized for specific use cases;
              </p>
              <p>
                Parathread: similar to parachains but with flexible connectivity
                based on an economical pay-as-you-go model;
              </p>
              <p>
                Bridges: allows parachains and parathreads to connect and
                communicate with external blockchains like Ethereum.
              </p>
            </div>

            <div className="container-fluid" id="Binance-Peg TrueUSD Token">
              <h1 className="mt-4">Binance-Peg TrueUSD</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2021-04-06
              </p>
              <p>
                <b>Total Supply</b>：813,000,000
              </p>
              <p>
                <b>Circulation</b>：--
              </p>
              <p>
                <b>White paper</b>：https://trueusd.com/pdf/TUSD_WhitePaper.pdf
              </p>
              <p>
                <b>Website</b>：https://trueusd.com/{" "}
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0x14016e85a25aeb13065688cafb43044c2ef86784
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                TrueUSD is a U.S. dollar stablecoin pegged to USD at 1:1. First
                launched to a limited investor base in January 2018, TrueUSD has
                since grown to incorporate almost $400 million of backed tokens as
                of October 2020.
              </p>

              <p>
                TrueUSD is one of a number of cryptocurrency stablecoins
                administered by TrustToken, a platform for tokenizing real-world
                assets.
              </p>

              <p>
                {" "}
                As with other stablecoins, TrueUSD aims to facilitate increased
                liquidity and provide cryptocurrency traders and general users with
                a nonvolatile asset relative to free-floating tokens such as Bitcoin
                (BTC).
              </p>
            </div>

            <div className="container-fluid" id="Binance-Peg Uniswap">
              <h1 className="mt-4">Binance-Peg Uniswap</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2020-10-13
              </p>
              <p>
                <b>Total Supply</b>：4,199,999.999999 UNI
              </p>
              <p>
                <b>Circulation</b>：2,685,334.060012
              </p>
              <p>
                <b>White paper</b>：https://uniswap.org/whitepaper.pdf
              </p>
              <p>
                <b>Website</b>：https://uniswap.org/{" "}
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0xbf5140a22578168fd562dccf235e5d43a02ce9b1
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                Uniswap is a popular decentralized trading protocol, known for its
                role in facilitating automated trading of decentralized finance
                (DeFi) tokens.
              </p>

              <p>
                An example of an automated market maker (AMM), Uniswap launched in
                November 2018, but has gained considerable popularity this year
                thanks to the DeFi phenomenon and associated surge in token trading.
              </p>

              <p>
                Uniswap aims to keep token trading automated and completely open to
                anyone who holds tokens, while improving the efficiency of trading
                versus that on traditional exchanges.
              </p>

              <p>
                Uniswap creates more efficiency by solving liquidity issues with
                automated solutions, avoiding the problems which plagued the first
                decentralized exchanges.
              </p>

              <p>
                In September 2020, Uniswap went a step further by creating and
                awarding its own governance token, UNI, to past users of the
                protocol. This added both profitability potential and the ability
                for users to shape its future — an attractive aspect of
                decentralized entities.Founded in 2017, Chainlink is a blockchain
                abstraction layer that enables universally connected smart
                contracts. Through a decentralized oracle network, Chainlink allows
                blockchains to securely interact with external data feeds, events
                and payment methods, providing the critical off-chain information
                needed by complex smart contracts to become the dominant form of
                digital agreement.
              </p>
            </div>
            <div className="container-fluid" id="USDC(USD Coin)">
              <h1 className="mt-4">USDC (USD Coin)</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2018-09-23
              </p>
              <p>
                <b>Total Supply</b>：2,856,939,253
              </p>
              <p>
                <b>Circulation</b>：2,856,939,253
              </p>
              <p>
                <b>White paper</b>：https://www.centre.io/pdfs/centre-whitepaper.pdf
              </p>
              <p>
                <b>Website</b>：https://www.centre.io/
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://etherscan.io/token/0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                Token Introduction: USD Coin (USDC) is a stablecoin fully backed by
                the US dollar and developed by the Centre consortium. Centre issues
                and redeems USDC without any extra fee and is licensed as a
                money-transmitter in the US and as an e-money institution in Europe.
                USDC can always be redeemed 1:1 to US dollars. Funds (for
                collateral) are held in segregated bank accounts, that are monitored
                and audited by third-parties. USD Coin has become one of the largest
                stablecoins (with a supply approaching a billion), its support has
                been extended to multiple decentralized applications (e.g., DeFi)
                and a wide variety of exchanges (e.g., Coinbase, Binance, Kraken).
              </p>
            </div>
            <div className="container-fluid" id="USDT(Tether)">
              <h1 className="mt-4">USDT (Tether)</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：--
              </p>
              <p>
                <b>Total Supply</b>：2,830,000,000
              </p>
              <p>
                <b>Circulation</b>：2,507,000,000
              </p>
              <p>
                <b>White paper</b>
                ：https://tether.to/wp-content/uploads/2016/06/TetherWhitePaper.pdf
              </p>
              <p>
                <b>Website</b>：https://tether.to/
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://etherscan.io/token/0xdac17f958d2ee523a2206206994597c13d831ec7
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                USDT is a crypto-currency asset issued on the Bitcoin blockchain via
                the Omni Layer Protocol. Each USDT unit is backed by a U.S Dollar
                held in the reserves of the Tether Limited and can be redeemed
                through the Tether Platform. USDT can be transferred, stored, spent,
                just like Bitcoins or any other crypto-currency.USDT and other
                Tether currencies were created to facilitate the transfer of
                national currencies, to provide users with a stable alternative to
                Bitcoin and to provide an alternative for exchange and wallet audits
                which are currently unreliable. USDT provides an alternative to
                Proof of Solvency methods by introducing a Proof of Reserves
                Process. In the Tether Proof of Reserves system, the amount of USDT
                in circulations can be easily checked on the Bitcoin blockchain via
                the tools provided at Omnichest.info, while the corresponding total
                amount of USD held reserves is proved by publishing the bank balance
                and undergoing periodic audits by professionals.
              </p>
            </div>

            <div className="container-fluid" id="Binance-Peg XRP Token">
              <h1 className="mt-4">Binance-Peg XRP</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2021-04-06
              </p>
              <p>
                <b>Total Supply</b>：217,000,000 XRP
              </p>
              <p>
                <b>Circulation</b>：196,925,364.574979
              </p>
              <p>
                <b>White paper</b>
                ：https://ripple.com/wp-content/uploads/2021/01/cbdc-whitepaper-2020.pdf
              </p>
              <p>
                <b>Website</b>：https://ripple.com/xrp/{" "}
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                To begin with, it’s important to understand the difference between
                XRP, Ripple and RippleNet. XRP is the currency that runs on a
                digital payment platform called RippleNet, which is on top of a
                distributed ledger database called XRP Ledger. While RippleNet is
                run by a company called Ripple, the XRP Ledger is open-source and is
                not based on blockchain, but rather the previously mentioned
                distributed ledger database.
              </p>

              <p>
                To learn more about this project, check out our deep dive of XRP.
              </p>

              <p>
                The RippleNet payment platform is a real-time gross settlement
                (RTGS) system that aims to enable instant monetary transactions
                globally. While XRP is the cryptocurrency native to the XRP Ledger,
                you can actually use any currency to transact on the platform.
              </p>

              <p>
                While the idea behind the Ripple payment platform was first voiced
                in 2004 by Ryan Fugger, it wasn’t until Jed McCaleb and Chris Larson
                took over the project in 2012 that Ripple began to be built (at the
                time, it was also called OpenCoin).
              </p>
            </div>

            <div className="container-fluid" id="XVS">
              <h1 className="mt-4">XVS (Venus)</h1>
              <p>
                <b>Project basic information</b>
              </p>
              <p>
                <b>Issue Time</b>：2020-09-27
              </p>
              <p>
                <b>Total Supply</b>：30,000,000 XVS
              </p>
              <p>
                <b>Circulation</b>：29,995,546.822815
              </p>
              <p>
                <b>White paper</b>：https://venus.io/Whitepaper.pdf
              </p>
              <p>
                <b>Website</b>：http://venus.io/{" "}
              </p>
              <p>
                <b>Block Explorer</b>
                ：https://bscscan.com/token/0xcf6bb5389c92bdda8a3747ddb454cb7a64626c63
              </p>

              <br />

              <p>
                <b>Project Introduction</b>
              </p>

              <br />

              <p>
                Venus is an algorithmic money market and synthetic stablecoin
                protocol launched exclusively on Binance Smart Chain (BSC).
              </p>

              <p>
                The protocol introduces a simple-to-use crypto asset lending and
                borrowing solution to the decentralized finance (DeFi) ecosystem,
                enabling users to directly borrow against collateral at high speed
                while losing less to transaction fees. In addition, Venus allows
                users to mint VAI stablecoins on-demand within seconds by posting at
                least 200% collateral to the Venus smart contract.
              </p>

              <p>
                VAI tokens are synthetic BEP-20 token assets that are pegged to the
                value of one U.S. dollar (USD), whereas XVS tokens are also
                BEP-20-based, but are instead used for governance of the Venus
                protocol, and can be used to vote on adjustments—including adding
                new collateral types, changing parameters and organizing product
                improvements.
              </p>

              <p>
                The governance of the protocol is entirely controlled by XVS
                community members, since the Venus founders, team members and other
                advisors do have any XVS token allocations.
              </p>
            </div>
          </div>
        </div>
      </TokenInfoCont>
    </TokenInfoWrapper>

  );
};

export default PlanetToken;
